module.exports = __webpack_public_path__ + "static/media/291978.a8b8c01e.png";